import apiClient from "@/api/client";
import type { ConstructionBoard, ConstructionStageState } from "./types";

const BASE = "/construction";

async function unwrap<T>(p: Promise<{ data: { data: T } }>): Promise<T> {
  const r = await p;
  return r.data.data;
}

export const getBoard = (project: string) =>
  unwrap<ConstructionBoard>(apiClient.get(`${BASE}/board/`, { params: { project } }));

export const seedStages = (project: string) =>
  unwrap<ConstructionBoard>(apiClient.post(`${BASE}/seed/`, { project }));

export const patchStage = (
  id: string,
  data: {
    state?: ConstructionStageState;
    due_date?: string | null;
    note?: string;
    label?: string;
    depends_on?: string[];
  },
) => unwrap<unknown>(apiClient.patch(`${BASE}/stages/${id}/`, data));

export const addStage = (data: {
  project: string;
  label: string;
  depends_on?: string[];
  due_date?: string | null;
}) => unwrap<{ id: string }>(apiClient.post(`${BASE}/stages/`, data));

export const deleteStage = (id: string) => apiClient.delete(`${BASE}/stages/${id}/`);
